import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question:
      "¿Qué opciones quedan cuando nada ha funcionado para la depresión?",
    answer:
      "Cuando los tratamientos anteriores no han funcionado, existen opciones autorizadas por la FDA como SAINT® para el trastorno depresivo mayor en adultos que no han mejorado con antidepresivos. El enfoque se evalúa en una consulta con el equipo clínico.",
  },
];

export const esOptionsWhenNothingWorks = makeEsArticle({
  slug: "what-options-are-left-when-nothing-works-for-depression",
  title: "Qué opciones quedan cuando nada funciona para la depresión",
  description:
    "Cuando los tratamientos anteriores no han funcionado, SAINT® y otras opciones autorizadas por la FDA pueden ayudar al trastorno depresivo mayor en adultos que no han mejorado con antidepresivos.",
  h1: "Qué opciones quedan cuando nada funciona",
  breadcrumbLabel: "Opciones cuando nada funciona",
  shortAnswer:
    "Cuando los antidepresivos y la psicoterapia no han funcionado lo suficiente, aún quedan opciones autorizadas por la FDA para el trastorno depresivo mayor. SAINT® es una TMS acelerada con orientación por fMRI, administrada en cinco días, indicada para adultos que no han mejorado con antidepresivos. No hay garantías de resultados; los resultados individuales pueden variar. El enfoque para cada persona se evalúa en una consulta con el equipo clínico.",
  keyTakeaways: [
    "Aún quedan opciones cuando los tratamientos anteriores no han funcionado.",
    "SAINT® está autorizada por la FDA para el trastorno depresivo mayor.",
    "SAINT® está indicada para adultos que no han mejorado con antidepresivos.",
    "No hay garantías de resultados; los resultados pueden variar.",
    "El enfoque se evalúa en una consulta.",
  ],
  sections: [
    {
      heading: "Opciones que quedan",
      paragraphs: [
        "Si los antidepresivos y la psicoterapia no han producido una mejoría suficiente, las opciones autorizadas por la FDA incluyen la TMS convencional y SAINT®. SAINT® combina un calendario de cinco días, orientación por fMRI y patrón theta burst.",
      ],
    },
    {
      heading: "Expectativas realistas",
      paragraphs: [
        "No todo el mundo alcanza la remisión. En los estudios de Stanford, una proporción de los participantes alcanzó la remisión tras cinco días (Cole et al., Am J Psychiatry 2020; 2022). Los resultados individuales pueden variar y no están garantizados.",
        "El mejor siguiente paso es una consulta con el equipo clínico para evaluar si SAINT® es adecuada para su situación. [[Solicite una consulta|/es/saint]] o llame al 954-827-9793.",
      ],
    },
  ],
  faqs,
  sources: [
    {
      citation:
        "Cole EJ, et al. Stanford Neuromodulation Therapy (SNT): A Double-Blind Randomized Controlled Trial. Am J Psychiatry. 2022;179(2):132-141.",
      url: "https://doi.org/10.1176/appi.ajp.2021.20101429",
    },
  ],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
